import React from "react";
// node-modules
import Icon from "@mdi/react";
import { mdiClockOutline } from "@mdi/js";
// styles
import { Container } from "../../styles/align";
import { Button } from "../../styles/forms";
import { StyleSuccess } from "./style";

const Success = props => {
  const { pk_pedido } = props.match.params;
  return (
    <Container>
      <StyleSuccess>
        <Icon path={mdiClockOutline} title={"Sucesso"} size={5} />
        <h2>Seu pedido foi recebido com sucesso</h2>
        <h2>Verifique o status de pagamento</h2>
        <p>
          Número do pedido:<strong>{pk_pedido}</strong>
        </p>
        <Button onClick={() => props.history.push(`/pedido/${pk_pedido}`)}>
          Acompanhe seu pedido
        </Button>
      </StyleSuccess>
    </Container>
  );
};

export default Success;
